import { render, staticRenderFns } from "./positionElement.vue?vue&type=template&id=02ec92e6&scoped=true&"
import script from "./positionElement.vue?vue&type=script&lang=js&"
export * from "./positionElement.vue?vue&type=script&lang=js&"
import style0 from "./positionElement.vue?vue&type=style&index=0&id=02ec92e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ec92e6",
  null
  
)

export default component.exports